import template from './datasets-tabular-result.hbs'
import i18n from 'scoreboard/components/i18n'
import { shortenedAndUnshortened } from 'scoreboard/components/format-value'
import _ from 'lodash'
import $ from 'jquery'
import DatasetsResult from './datasets-result'
import Immutable from 'immutable'
var Set = Immutable.Set
var Map = Immutable.Map
import cleanObject from 'scoreboard/components/clean-object'
import ChooseColumns from './choose-columns'
import DatasetField from '../model/dataset-field'
import calendars from 'scoreboard/components/calendars'
import getChooseSummaryTypeDefault from './get-choose-summary-type-default'
import KeyDisplay from '../key-display'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import moment from 'moment'
import daysOfTheWeek from 'scoreboard/components/days-of-the-week'
import monthsOfTheYear from 'scoreboard/components/months-of-the-year'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import aggregationLabel from './aggregation-label'
import applyFilter, { matchingFilter } from '../apply-filter'
import SortableTableView from 'scoreboard/components/sortable-table-view'
import Backbone from 'backbone'
import locale from 'scoreboard/components/locale'
import DefaultSorter from 'scoreboard/components/sorter'
import loadingDotsTbody from 'scoreboard/components/loading-dots-table-body.hbs'
import LoadingDots from 'scoreboard/components/loading-dots'
import unwrapModel from 'scoreboard/components/unwrap-model'
import Dataset, { ROLLUPS_NOT_VIEWABLE } from 'scoreboard/datasets/model/dataset'
const { isTotal, TOTAL } = Dataset
import datasetValuePrecision from '../dataset-value-precision'
import coerceNilAggregatedValue from 'scoreboard/components/coerce-nil-aggregated-value'
import formatSummaryValue from 'scoreboard/datasets/overview/format-summary-value'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'
import { getRepeatByGroupingKey } from './get-repeat-by-grouping'
import icon from 'scoreboard/components/icon'
import showPartialError from 'scoreboard/datasets/show-partial-error'
import { isDayOfTheWeek, isMonthOfTheYear } from 'scoreboard/datasets/is-compare-all-time'
import isGeographicOrRollup from 'scoreboard/datasets/is-geographic-or-rollup'
import SummaryType from 'scoreboard/datasets/model/summary-type'
const { HOUR_OF_THE_DAY } = SummaryType
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, TEXT, YES_NO, DATE, TIME, DATE_TIME, CALENDAR_PERIOD } = DataType
import getAggregatedDataType from 'scoreboard/components/get-aggregated-data-type'
import combineFilters from 'scoreboard/datasets/filters/combine-filters'
import formatHtmlValue from 'scoreboard/components/format-html-value'
import { LIST_UNIQUE_VALUES } from '../model/aggregation-type'

// how many results to display initially, and how many additional results to
// display each time the user requests to see more results
var RENDER_INCREMENT = 5

// Used to store/lookup other aggregation raw data (needed for excel export)
const OTHER_KEY = cleanObject({ value: 'other' })

// IDs used for Other and Is Blank rows
var OTHER = 'other'
var NOT_IN_ANY = 'not-in-any'
const BLANK = Dataset.BLANK

// indicates sort on the primary field on the table
const TABLE_FIELD = 'table-field'

// indicates sort on keys on a rollup field on the table
const ROLLUP_FIELD_KEYS = 'rollup-field-keys'

// indicates sort on ancestors on a rollup field on the table
const ROLLUP_FIELD_ANCESTORS = 'rollup-field-ancestors'

// indicates sort on the breakdown row
const BREAKDOWN_ROW = 'breakdown-row'

const DEFAULT_SORT_STATE = {sortField: null, ascending: true}

//Sorter that ensure handling of special values found in dataset tables
class Sorter extends DefaultSorter {
	compare (a, b) {
		//#21328 treat "-" like a null and always put at the bottom but before nulls
		if (a === ROLLUPS_NOT_VIEWABLE) {
			if (b === ROLLUPS_NOT_VIEWABLE) {
				return 0
			} else if (this.isNil(b)) {
				return -1
			} else {
				return this.opts.nilsFirst ? -1 : 1
			}
		} else if (b === ROLLUPS_NOT_VIEWABLE) {
			if (this.isNil(a)) {
				return 1
			}  else {
				return this.opts.nilsFirst ? 1 : -1
			}
		}
		return super.compare(a,b)
	}
}

// creates the HTML for a keys header (must be in a callback b/c i18n data isn't
// loaded when this file first loads)
var keysHeaderHtml = function() {
	return `<th class="is-sortable" data-sort-field="${ROLLUP_FIELD_KEYS}">` + _.escape(i18n.get('datasets.trees.keys.noArg')) + '</th>'
}

function assignIndexes(object) {
	let keys = _.keys(object)
	let indexes = {}
	_.each(keys, (key, index) => {
		// make sure nothing is 0 based so that we can use the || operator in
		// dateSortValue
		indexes[key] = index + 1
	})
	return indexes
}

let daysOfTheWeekIndexes = assignIndexes(daysOfTheWeek())
let monthsOfTheYearIndexes = assignIndexes(monthsOfTheYear())

/**
 * Returns a value that can be used by getFieldSorter to sort two date values
 */
function dateSortValue(value) {
	return daysOfTheWeekIndexes[value] || monthsOfTheYearIndexes[value] ||
		// newer periods go before older periods
		(-1 * calendars.periodsById[value].end.unix())
}

/**
 * Returns an object containing the breakdown column index and aggregation column index
 * this sort field represents
 */
let parseColumnSortField = _.memoize(function(sortField) {
	if (!sortField || sortField.indexOf(',') == -1) return null
	let colAggIndexes = _(sortField.split(',')).map(_.ary(parseInt, 1)).value()
	return {
		breakdownIndex: colAggIndexes[0],
		aggregationIndex: colAggIndexes[1]
	}
})

/**
 * Helper for getting the sort field from aggregation metadata coordinates
 * @param {{x: number, y: number}} coordinates
 * @returns {string}
 */
function getAggregationSortField(coordinates) {
	return `${coordinates.y},${coordinates.x}`
}

/**
 * Takes an map keyed by node id whose value is an tree node that has a 'children' property that contains all the children
 * for that particular node.  Returns a new map keyed by node id whose value is the numerical order of the node that has
 * been sorted by the sorter passed without altering the parental structure of the heirarchy itself (i.e. sibling
 * nodes are sorted relative to each other while maintaining their position relative to their parents and children)
 */
function orderWithGrandDescendants(itemMap, sorter) {
	let collectOrderTreeWalker = (node, order, nodeMap) => {
		nodeMap[node.id] = order++
		if (node.children) {
			_.each(node.children, child => {
				order = collectOrderTreeWalker(itemMap[child.id], order, nodeMap)
			})
		}
		return order
	}

	//sort each level using the given sorter
	_.each(itemMap, item => item.children = sorter.sort(item.children).results)

	//then return the order of nodes in the tree
	let orderMap = {}
	let order = 0
	_.each(itemMap['root'].children, root => {
		order = collectOrderTreeWalker(itemMap[root.id], order, orderMap)
	})
	return orderMap
}

/**
 * Shows dataset data broken into categories.  For date fields the categories
 * are calendar periods, for fields with ranges it's the different
 * ranges, etc.
 *
 * @class DatasetsTabularResult
 */
var DatasetsTabularResult = DatasetsResult.extend({

	events: _.extend({}, DatasetsResult.prototype.events, {
		// #15412 be sure the selector contains tr[data-id], because without the
		// ID the software won't know where to drilldown.  Some drilldowns
		// aren't supported until #13073 is implemented
		'click tr[data-id] .drilldown': 'clickRow',
		'click .result-error': 'onClickResultError',
		'click .aggregation-error': 'onClickAggregationError'
	}),

	/**
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Object} options.field the field this result is based on
	 *
	 * @param {DatasetTable} options.table the table settings for the result
	 *
	 * @param {Array} options.allFilters all the filters that currently apply
	 * to the Datasets Overview
	 *
	 * @param {Object} options.result the raw result returned by the server
	 *
	 * @param {Object} options.treeItemsById a hash of tree IDs to tree items
	 *
	 * @param {String} options.blank the number of items which had no value for
	 * the field
	 *
	 * @param {Number} options.numResults the total number of results
	 *
	 * @param {Number} options.aggregationFieldId the default aggregation field ID
	 *
	 * @param {Number} options.aggregationVisibleLinkedFieldId the default
	 * visible linked field use for aggregation
	 *
	 * @param {String} options.aggregationType the default aggregation type
	 *
	 * @param {Object} options.filtersByLinkGroup a hash of filters by linkGroup
	 *
	 * @param {Object} options.request the whole DatasetsQueryRequest
	 *
	 * @param {Object} options.response the whole DatasetsQueryResponse
	 *
	 * @param {Boolean} options.explore true if we're on the datasets explore
	 * tab. In that case, the clickable dataset values should be highlighted.
	 */
	initialize: function(options = {}) {
		DatasetsResult.prototype.initialize.apply(this, arguments)
		if (_.get(this.options, 'result.error')) return

		const table = this.options.table

		this.underlyingField = this.model.getUnderlyingField(this.options.field)
		this.groupCalendar = calendars.calendarsById[table && table.get('groupCalendarId')]
		this.breakdownCalendar = calendars.calendarsById[table && table.get('breakdownCalendarId')]

		//#26071 ensure when showing just children, the default sort is descending
		//otherwise if showing children and has a breakdown (#23969) or if sorting
		//by grand-children or great-grandchildren (#19184) use the tree structure
		this.sortDefaultByRollupTree = isGeographicOrRollup(this.underlyingField.dataType) &&
			((this.getSummaryType() == 'tree'  && this.hasBreakdown()) || this.getSummaryType() == 'grandchildren' || this.getSummaryType() == 'great-grandchildren')

		//#17269 only need to create the collator once, init at beginning for default sorting
		this.collator = new Intl.Collator(locale().locale, {sensitivity: 'base', numeric: true})

		this.keyDisplay = new KeyDisplay(options)

		this.numDisplayed = this.isShowingAll() ? Number.MAX_VALUE :
			(table && table.get('numResults') || RENDER_INCREMENT)

		// indicates that the leftmost column displays ranges
		// must be before the sorting below
		this.showingRangesForValues = false
		let summaryType = table && table.get('summaryType')
		if (summaryType === 'range') {
			this.showingRangesForValues = true
		}
		if (!summaryType && getChooseSummaryTypeDefault(this.options.field, this.filters, this.model) == 'range') {
			this.showingRangesForValues = true
		}
		// #23845 can't use ranges if there aren't any
		if (_.isEmpty(this.underlyingField.ranges)) {
			this.showingRangesForValues = false
		}

		// before creating this.valueArray
		this.treeInfoById = _.keyBy(_.get(options, 'result.treeInfo'), 'id')

		// prepare this.valueArray, this.rowArray, this.columnArray, which are
		// sorted arrays that determine the order of the values in the table,
		// row breakdown values, and column breakdown values.
		var keys = [ 'value' ]
		if (_.get(options.table.get(getRepeatByGroupingKey('row')), 'fieldId')) {
			keys.push('row')
		} else {
			this.rowArray = [ undefined ]
		}
		if (_.get(options.table.get(getRepeatByGroupingKey('column')), 'fieldId')) {
			keys.push('column')
		} else {
			this.columnArray = [ undefined ]
		}
		let data = _.get(this.options, 'result.data')
		_.each(keys, function(field) {
			// find all the unique values
			var set = new Set(_.map(data, field))
			var sorted = this['sort' + _.capitalize(field) + 'sByDefaultOrder'](set.toJS())
			this[field + 'Array'] = sorted
			//keep a copy of the default order for resetting back to default sort
			this[field + 'ArrayDefaultOrder'] = [].concat(sorted)
		}.bind(this))

		this.map = new Map()
			.withMutations(function(state) {
				_.each(data, function(datum) {
					var key = Immutable.fromJS(cleanObject(_.pick(datum, keys)))
					state.set(key, datum.aggregations)
				})
				if (_.get(this.options, 'result.others')) {
					state.set(Immutable.fromJS(OTHER_KEY),
						this.options.result.others[this.numDisplayed])
				}
			}.bind(this))

		//certain aggregations use a 0 for the nil or missing values, we need to account for those cases when sorting
		//see the method aggregationHtml
		let sortData = {values: []}
		let aggregationDataTypes = []
		let aggregations = this.getAggregations()
		if (this.options.table) {
			let colIndexWithPercent = []
			let defaultColumnValues = []
			_.each(aggregations, (agg, idx) => {
				let dataType = NUMBER
				let aggType = 'sum'
				if (!isTotal(agg.fieldId)) {
					let field = this.model.combinedFieldsById[agg.fieldId]
					// FIXME
					dataType = _.get(field, 'dataType', NUMBER)
					aggType = _.get(agg, 'aggregationType', 'sum')
				}
				aggregationDataTypes[idx] = dataType

				//certain columns use 0 for nulls
				defaultColumnValues[idx] = null
				if (dataType !== DATE && (aggType === 'sum' || aggType === 'percentage')) {
					defaultColumnValues[idx] = 0
				}
				if (aggType === 'percentage') {
					colIndexWithPercent.push(idx)
				}
			})

			let dataMap = {}
			//defined a default column array containing the potential 0s (some columns may be missing from the results
			//returned by the server instead of sending nulls, so we need to fill the data with 0s)
			let normalizedColumnValueArray = []
			_.each(this.columnArray, (val, idx) => {
				normalizedColumnValueArray[idx] = [].concat(defaultColumnValues)
			})

			_.each(_.result(this.options, 'result.data'), item => {
				//the fieldSorter will handle the various types of data formats so we don't need to format that here
				let data = _.get(dataMap, item.value, {
					id: item.value,
					value: item.value,
					columnValues: [].concat(normalizedColumnValueArray)
				})

				let colIndex = 0
				if (!_.isNil(item.column)) {
					//if there are column breakdowns, assign the correct aggregation to the corresponding column index
					colIndex = _.findIndex(this.columnArray, col => item.column == col)
				}

				if (colIndex != -1) {
					let values = _.map(normalizedColumnValueArray[colIndex], (val, idx) => {
						return _.get(item.aggregations,`[${idx}]`) || val
					})
					//normalize percent values to properly sort with 0% (e.g. the value .23 = 23)
					_.each(colIndexWithPercent, idx => values[idx] = values[idx] * 100)
					data.columnValues[colIndex] = values
				}

				//normalize the value of the the aggregations that use dates into a numerical value for sorting
				for (let ci=0; ci<data.columnValues.length; ci++) {
					for (let ai=0; ai<aggregations.length; ai++) {
						data.columnValues[ci][ai] = this.getAggregationComparable(data.columnValues[ci][ai], ai)
					}
				}

				dataMap[data.value] = data
			})
			sortData.values = _.values(dataMap)

			//#19184 implement sorting with grand descendants
			if (this.sortDefaultByRollupTree) {
				let itemMap = {'root': {children:[]}}
				sortData.ascendingGrandchildren = []
				sortData.descendingGrandchildren = []

				// create a map where each node contains a reference to it's children and has the values used to sort with
				// this will be used to keep the parent/children relationships intact as we sort the siblings
				_.each(_.sortBy(this.treeInfoById, 'leftBound'), item => {
					let columnValues = _.get(dataMap[item.id], 'columnValues', [])
					itemMap[item.id] = {children:[], columnValues, id: item.id}
					if (itemMap[item.parentId]) {
						itemMap[item.parentId].children.push(item)
					} else {
						itemMap['root'].children.push(item)
					}
				})

				//sort the table-field by grand-descendants
				let tableFieldGrandDescendantsSorter =  new Sorter({
					alphanumeric: this.isTableFieldAlphanumeric(),
					compare: this.getFieldComparator(this.underlyingField, this.showingRangesForValues),
					toValue: item => item.id
				})
				sortData.ascendingGrandDescendantsByTableField = orderWithGrandDescendants(itemMap, tableFieldGrandDescendantsSorter)
				sortData.descendingGrandDescendantsByTableField = orderWithGrandDescendants(itemMap,
					tableFieldGrandDescendantsSorter.options({reversed: true}))

				//for each breakdown/aggregation pair return the ascending and descending order of nodes in the tree based on the values
				//in each row while keeping the parent/child relationships intact.
				for (let breakdownIndex=0; breakdownIndex<this.columnArray.length; breakdownIndex++) {
					let ascendingAggregations = []
					let descendingAggregations = []
					for (let aggregationIndex=0; aggregationIndex<aggregations.length; aggregationIndex++) {
						let columnSorter = new Sorter({
							alphanumeric: false,
							toValue: item => {
								let row = itemMap[item.id].columnValues[breakdownIndex]
								return row ? row[aggregationIndex] : undefined
							}
						})
						ascendingAggregations.push(orderWithGrandDescendants(itemMap, columnSorter))
						descendingAggregations.push(orderWithGrandDescendants(itemMap, columnSorter.options({reversed: true})))
					}
					sortData.ascendingGrandchildren.push(ascendingAggregations)
					sortData.descendingGrandchildren.push(descendingAggregations)
				}
			}

			//#17268 implement sorting by rollup keys
			let treeItems = _.values(this.options.treeItemsById)
			let treeItemsByAscendingKeys = new Sorter({
				toValue: (treeItem) => {
					return this.keyDisplay.keys(treeItem.id)
				},
				collator: this.collator
			}).sort(treeItems).results
			sortData.ascendingKeysUsingTreeId = _.map(treeItemsByAscendingKeys, 'id')

			//#17268 implement sorting by rollup ancestors
			let ancestorsToIdLabelList = _.map(_.get(this.options.response, 'ancestors'), (val, key) => {
				return {id: parseInt(key, 10), label: val}
			})
			let ascendingAncestors = new Sorter({collator: this.collator}).sort(ancestorsToIdLabelList, 'label').results
			sortData.ascendingAncestorsUsingTreeId = _.map(ascendingAncestors, 'id')

			//use the already computed rowArray to ensure blank values are included in the sort #17259
			if (this.rowArray.length > 1) {
				//normalize to an array of objects having a value property
				sortData.rows = _.map(this.rowArray, val => { return {value: val} })
			}
		}

		//add sorting to the table
		this.sortableTable = new SortableTableView({
			el: this.el,
			data: (sortField, state) => {
				//use the correct data depending on value/column sorting vs breakdown row sorting
				return sortField == BREAKDOWN_ROW && !_.isNil(sortData.rows) ? [].concat(sortData.rows) : [].concat(sortData.values)
			},
			defaultSort: () => {
				return { useDefaultSort: true }
			},
			applySortingOptions: (sorterOpts, sortField, state) => {
				//note sorting by breakdown does not required a compound sort because "Other" rows are not shown
				//when breakdowns exists (the entire data set is already showing)
				if (sortField == TABLE_FIELD) {
					sorterOpts.alphanumeric = this.isTableFieldAlphanumeric()
					//when sorting by the main field, use custom compare function to handle all the potential
					//values in a field
					sorterOpts.compare = this.getFieldComparator(this.underlyingField, this.showingRangesForValues)
				} else if (sortField == BREAKDOWN_ROW) {
					sorterOpts.alphanumeric = this.isBreakdownFieldAlphanumeric('row')
					sorterOpts.compare = this.getBreakdownComparator('row')
				} else if (sortField == ROLLUP_FIELD_KEYS || sortField == ROLLUP_FIELD_ANCESTORS) {
					//sorting on rollup key/ancestor fields is numerical because we're using a sorted key array indexed
					//by tree id so that value compared is the index of the sorted array
					sorterOpts.alphanumeric = false
					sorterOpts.compound = this.getValueSorter()
				} else {
					//dataset breakdown columns are aggregations which should always be numerical
					sorterOpts.alphanumeric = false
					//#15374 handle ties so that the "Other" value is correct
					sorterOpts.compound = this.getValueSorter()
				}

				//special case with rollup grandDescendants, the value given to the sorter here is already ordered
				//so just return the natural ordering
				if (sortField != ROLLUP_FIELD_KEYS && sortField != ROLLUP_FIELD_ANCESTORS && sortField != BREAKDOWN_ROW
					&& this.sortDefaultByRollupTree) {
					sorterOpts.compare = (a,b) => a-b
				}

				sorterOpts.collator = this.collator
				return sorterOpts
			},
			extractSortData: (item, field, state) => {
				let val = item.value
				if (field == ROLLUP_FIELD_KEYS) {
					val = sortData.ascendingKeysUsingTreeId.indexOf(val)
				} else if (field == ROLLUP_FIELD_ANCESTORS) {
					val = sortData.ascendingAncestorsUsingTreeId.indexOf(val)
				} else if (field != TABLE_FIELD && field != BREAKDOWN_ROW) {
					let column = parseColumnSortField(field)
					val = item.columnValues[column.breakdownIndex][column.aggregationIndex]
					if (this.sortDefaultByRollupTree) {
						let orderMap = state.ascending ? sortData.ascendingGrandchildren : sortData.descendingGrandchildren
						val = orderMap[column.breakdownIndex][column.aggregationIndex][item.id]
					}
				} else if (field == TABLE_FIELD && this.sortDefaultByRollupTree) {
					let numericalOrderByNodeId = state.ascending ? sortData.ascendingGrandDescendantsByTableField
						: sortData.descendingGrandDescendantsByTableField
					val = numericalOrderByNodeId[item.id]
				}
				return val
			}
		}).on('sorted', (data) => {
			let defaultValueOrder = [].concat(this.valueArrayDefaultOrder)
			let defaultRowOrder = [].concat(this.rowArrayDefaultOrder)
			if (data.useDefaultSort) {
				this.valueArray = defaultValueOrder
				this.rowArray = defaultRowOrder
			} else {
				let vals = data.map(x => { return x.value})
				if (this.sortableTable.state().sortField == BREAKDOWN_ROW) {
					this.rowArray = vals
					this.valueArray = defaultValueOrder
				} else {
					this.valueArray = vals
					this.rowArray = defaultRowOrder
				}
			}

			this.currentSort = this.sortableTable.state()
			_.assign(this.options.table, this.currentSort)
			this.renderRows()
			this.trigger('sort')	//"this" is the dataset-tabular-result view, not the sortable table itself
		})

		//add loading dots if the sort takes some time (sorting huge numbers of rows)
		this.listenTo(this.sortableTable, 'sort', (field) => {
			this.$('table tbody').replaceWith(loadingDotsTbody())
			this.$('.loading-dots-row').removeClass('is-not-displayed')
			this.loadingDotsForLongSorts = new LoadingDots({
				el: this.$('tbody .loading-dots-container')
			}).render()
		})

		//apply initial sort if any
		let initialSort = table && table.get('sortField')
		if (initialSort) {
			//#17328 prevent invalid sort states from blowing up table
			if (!this._isSortFieldValid(initialSort)) {
				//reassign to default sort
				_.assign(this.options.table, DEFAULT_SORT_STATE)
			} else {
				let ascending = !!(table && table.get('ascending'))
				this.sortableTable.sort(initialSort, ascending)
			}

			//capture the current sort so we can go back to it when it's validity toggles between invalid and valid
			//based on the table display settings. #17328
			this.currentSort = this.sortableTable.state()
		}
	},

	render: function() {
		this.$el.empty().append(template())
		this.renderHeader()
		this.updateHeaderLabel()
		if (this.options.result.error) {
			this.renderError()
		} else {
			this.renderRows()
		}
		this.$('.loading-dots-container').append(loadingDots())
		return this
	},

	getAggregations: function() {
		let table = _.get(this.options, 'table', {})
		const aggregationVisibleLinkedFieldId = _.get(this.options, 'aggregationVisibleLinkedFieldId')
		return _.cloneDeep(ChooseColumns.aggregations(this.model, table,
			this.options.aggregationFieldId, aggregationVisibleLinkedFieldId,
			this.options.aggregationType,
			this.options.filterThroughLocalDataset))
	},

	/**
	 * @return {Object} the values for the "Other" row data based on current sort state
	 */
	getOtherDatum: function () {
		let otherData = this.options.result.others[this.numDisplayed]

		// use the default sort if the user hasn't done any sorting themselves (#19137)
		let datum = otherData.default
		let {sortField, ascending} = this.sortableTable.state()

		if (_.isNil(sortField)) {
			//if we're using the default sort and the aggregation on the first
			// column is minimum then we're using ascending order
			if (this.getAggregations()[0].aggregationType == 'minimum') {
				datum = otherData.ascendingAggregations[0]
			}
		} else if (sortField == TABLE_FIELD) {
			datum = ascending ? otherData.ascendingTableField : otherData.descendingTableField
		} else if (sortField == ROLLUP_FIELD_KEYS) {
			datum = ascending ? otherData.ascendingRollupFieldKeys : otherData.descendingRollupFieldKeys
		} else if (sortField == ROLLUP_FIELD_ANCESTORS) {
			datum = ascending ? otherData.ascendingRollupFieldAncestors : otherData.descendingRollupFieldAncestors
		} else {
			//note "Other" values are not present where there are breakdowns,
			// so we don't need to check to see if the sort is on a breakdown
			// column/row, we can just assume here the sort is on an
			// aggregation
			let otherAggData = ascending ? otherData.ascendingAggregations : otherData.descendingAggregations
			datum = otherAggData[parseColumnSortField(sortField).aggregationIndex]
		}
		return datum
	},

	/**
	 * Returns the ID of the tree node to be shown first in the results, with
	 * all its children indented under it.  Returns nil if this sort of
	 * indentation should not be performed
	 */
	getValueSortFirstTreeId: function() {
		let underlyingField = unwrapModel(this.model.getUnderlyingField(this.options.field))
		// figure out if we're doing row and value indents (issue #11524)
		var sortFirstTreeId = this.options.field && _.get(this.options.result, `sortFirstTreeIds.${this.options.field.id}`)
		// #17737 when no filter displayed, the root would be the one to display first
		if (isGeographicOrRollup(_.get(underlyingField, 'dataType')) && !sortFirstTreeId) {
			sortFirstTreeId = underlyingField.treeId
		}
		// #16127 if "List" was the option for "Choose Rows", there's no indentation
		if (this.getSummaryType() === 'list') {
			sortFirstTreeId = null
		}
		return sortFirstTreeId
	},

	/**
	 * Returns how the appropriate selection for "Choose Rows" for the table,
	 * which is stored in the "rows" attribute of the table.  If an explicit
	 * selection wasn't made, returns the default.
	 */
	getSummaryType: function() {
		const summaryType = this.options.table && this.options.table.get('summaryType')
		return summaryType || getChooseSummaryTypeDefault(this.options.field, this.filters, this.model)
	},

	renderError: function() {
		this.$('.panel-content').addClass('has-result-error').html('<div class="result-error">'
			+ icon('widget-empty-state') + '</div>')
	},

	initBeforeRenderRows: function() {
		this.aggregations = this.getAggregations()

		this.showKeys = this.keyDisplay.isDisplayed()
		this.showAncestors = this.options.table.get('showAncestors')

		this.rowBreakdownField = this.getBreakdownField('row')
		this.underlyingField = unwrapModel(this.model.getUnderlyingField(this.options.field))

		// figure out if we're doing row and value indents (issue #11524).  Screenshots:
		// https://github.com/SpiderStrategies/Scoreboard/issues/11524#issuecomment-327832271

		this.valueFirstId = this.getValueSortFirstTreeId()
		this.valueIndents = this.valueFirstId && _.includes(this.valueArray, parseInt(this.valueFirstId))
		this.rowIndents = false
		if (this.rowBreakdownField) {
			this.rowFirstId = _.get(this.options, `result.sortFirstTreeIds.${this.rowBreakdownField.id}`)
			this.rowIndents = this.rowFirstId && _.includes(this.rowArray, parseInt(this.rowFirstId))
		}

		//do not indent if not in default sort
		if (!_.isNil(this.sortableTable.state().sortField)) {
			this.rowIndents = this.valueIndents = false
		}
	},

	renderRows: function() {
		this.initBeforeRenderRows()

		var html =
			'<thead>' +
				this.columnBreakdownHeaderHtml() +
				this.normalHeaderHtml() +
			'</thead>' +
			'<tbody>' +
				this.dataTableHtml() +
				this.othersHtml() +
			'</tbody>'

		// render the table first so we can inspect it to see how many rows
		// were rendered within isHidingPanelContents.  If we end up hiding the
		// panel contents it wasn't like it was a lot of work to render the HTML
		// table because it would have been very small.
		this.$('table').html(html)
		if (this.isHidingPanelContents()) {
			this.$('.panel-content').addClass('is-not-displayed')
		}

		// If we're abbreviating numbers in our results, show nonAbbreviatedTooltips
		if (!this.options.suppressTooltips &&  _.get(this.options.table.attributes, 'abbreviateNumbers', true)) {
			this.setupNonAbbreviatedTooltips()
		}

		//#17328 keep the table updated with the most valid sort state
		let updatedSortState = this.currentSort || DEFAULT_SORT_STATE
		if (!this._isSortFieldValid(updatedSortState.sortField)) {
			//if the current sort is no longer valid due to table changes, use default sort
			updatedSortState = DEFAULT_SORT_STATE
		}
		_.assign(this.options.table, updatedSortState)

		//ensure sort indicator is showing
		this.sortableTable._applySortIndicator()

		//#17184 secure after rendering row since they can be re-rendered by sorting without
		//re-rendering the entire view
		this.secure()
	},

	/**
	 * Renders the first row of headers (only applies when there is a column
	 * breakdown)
	 * @returns {string}
	 */
	columnBreakdownHeaderHtml: function() {
		let label, html = ''
		var columnBreakdownField = this.getBreakdownField('column')
		if (columnBreakdownField) {
			// possible colspan text for the first header column.  We have a colspan
			// because the first column is for the values of the field this filter
			// corresponds to, and the second column is for the row breakdowns
			var colspan = 1
			if (this.showAncestors) colspan++
			if (this.showKeys) colspan++
			if (this.rowBreakdownField) {
				colspan++
				if (this.keyDisplay.isDisplayed() &&
					isGeographicOrRollup(this.rowBreakdownField.dataType)) {
					colspan++
				}
			}
			var colspanHtml = colspan > 1 ? ' colspan="' + colspan + '"' : ''
			html += '<tr>'
				+ '<th' + colspanHtml + '></th>'
			_.each(this.columnArray, function(column) {
				const columnBreakdown = this.options.table.get(getRepeatByGroupingKey('column'))
				label = this.fieldLabel(columnBreakdownField,
					(columnBreakdown && columnBreakdown.summaryType) === 'range',
					column, columnBreakdown)
				let isEscaped
				if (Dataset.isBlank(column)) {
					label = _.escape(label)
					label = this.model.getFieldLabelByIds(columnBreakdown) + ': ' + $(`<span class="blank-value">${label}</span>`)[0].outerHTML
					isEscaped = true
				}	else {
					label = this.model.getFieldLabelByIds(columnBreakdown) + ': ' + label
				}
				if (this.showKeys) {
					var text = this.keyDisplay.keys(column)
					if (!_.isEmpty(text)) {
						label += ' (' + _.escape(text) + ')'
					}
				}
				label = isEscaped ? label : _.escape(label)
				html +=
					`<th colspan=${this.aggregations.length} class="column-breakdown">` +
					label +
					'</th>'
			}.bind(this))
			html += '</tr>'
		}
		return html
	},

	/**
	 * Renders the second header row (which is the only header row when there
	 * is no column breakdown)
	 */
	normalHeaderHtml: function() {
		let html = '<tr>'

		// add the first column header
		if (this.showAncestors) {
			html += `<th class="is-sortable" data-sort-field="${ROLLUP_FIELD_ANCESTORS}">${_.escape(i18n.get('datasets.field.showAncestors.noArg'))}</th>`
		}
		let firstFieldLabel = this.firstFieldLabel()
		html += `<th data-sort-field="${TABLE_FIELD}" class="is-sortable">${firstFieldLabel}</th>`
		if (this.showKeys) {
			html += keysHeaderHtml()
		}
		// add second column header (only if there's a row breakdown)
		if (this.rowBreakdownField) {
			const rowBreakdown = this.options.table.get(getRepeatByGroupingKey('row'))
			html += `<th class="is-sortable" data-sort-field="${BREAKDOWN_ROW}">` +
				_.escape(this.model.getFieldLabelByIds(rowBreakdown)) +
				'</th>'
			if (this.showKeys && isGeographicOrRollup(this.rowBreakdownField.dataType)) {
				html += keysHeaderHtml()
			}
		}

		//this map tracks the column index to their respective column breakdown values
		this.columnIndexToColumnValue = {}

		_.each(this.aggregationsMetadata(this.aggregations), (metadata, columnIndex) => {
			const breakdownClass = metadata.columnBreakdown ? 'column-breakdown' : ''
			const isSortableClass = metadata.isSortable ? 'is-sortable' : ''
			const sortField = getAggregationSortField(metadata.coordinates)
			html +=
				`<th class="${breakdownClass} ${isSortableClass}"
					data-sort-field="${sortField}"
					data-column-index="${columnIndex}">
					${_.escape(metadata.text)} ${metadata.errorHtml}
				</th>`
		})
		return html
	},

	/**
	 * Renders the majority of the data in the table (just not the "Other" row
	 * at the bottom, and not the headers)
	 */
	dataTableHtml: function() {
		let label, html = ''
		_.each(this.valueArray, function(value, valueIndex) {
			// figure out values for row breakdowns for which we will return
			// results
			let rowsForValue = _.filter(this.rowArray, row => {
				// #17329 we only include the row if there are some results to
				// show in that row
				return _(this.columnArray)
					.map(column => {
						var key = cleanObject({value, row, column})
						return this.map.get(Immutable.fromJS(key))
					})
					.compact()
					.value()
					.length > 0
			})
			var rowspan = rowsForValue.length
			var rowspanStr = rowspan < 2 ? '' : (' rowspan="' + rowspan + '"')
			var data = ' data-id="' + (_.isUndefined(value) ? BLANK : _.escape(value)) + '"'

			// This is required so that excel exports know to treat the 'data-value'
			// as a string and not a number when constructing the Immutable.js key to
			// lookup the raw value
			if (typeof value === 'string') {
				data += ' data-value-type="text"'
			}

			// #16637 don't apply the same drilldown twice
			// what would a filter look like if we clicked on this row?
			var filter = applyFilter(this.underlyingField, [],
				_.cloneDeep(this.options.table), value)[0]
			let filtersByLinkGroup = _(this.allFilters)
				.filter(f => _.isNil(f.permissionId))
				.groupBy('linkGroup')
				.value()
			// if there was a matching filter that wasn't part of an or group,
			// don't allow a drilldown
			let match = matchingFilter(this.filters, filter, f => _.isNil(f.permissionId))
			if (match && _.size(filtersByLinkGroup[match.linkGroup]) <= 1) {
				data = ''
			}

			// disallow clicking on "not in any period"
			// https://github.com/SpiderStrategies/Scoreboard/issues/16622#issuecomment-377511429
			// https://github.com/SpiderStrategies/Scoreboard/issues/35879#issuecomment-790133533
			if (value === 'not-in-any' &&
				_.includes([DATE, DATE_TIME], this.options.field.dataType)) {
				data = ''
			}
			// #50785 disallow clicking on tables displaying "hour of day"
			let summaryType = unwrapModel(this.options.table).summaryType
			if (summaryType === HOUR_OF_THE_DAY) {
				data = ''
			}
			label = this.fieldLabel(new DatasetField(this.options.field),
				this.showingRangesForValues, value)
			var indent = '', levelStr = ''
			let treeDisplay =
				this.getSummaryType() == 'tree' ||
				this.getSummaryType() == 'grandchildren' ||
				this.getSummaryType() == 'great-grandchildren'

			let drilldownClass = 'drilldown'
			if (isGeographicOrRollup(this.underlyingField.dataType)) {
				if (this.valueIndents && value != this.valueFirstId &&
					// blanks go last when in a tree view, and aren't indented
					!(treeDisplay && Dataset.isBlank(value))) {
					indent = 'indent'
				}
				let level = _.get(this.treeInfoById, `${value}.level`)
				if (_.isNumber(level)) {
					levelStr = ` data-level="${level}"`
				}
				if (this.hasItemOnlyFilter(value, this.underlyingField.id)) {
					// If this node has item only or rollups only filter
					// don't allow drilldown
					drilldownClass = ''
				}
			}

			var breakdownRow = this.rowBreakdownField ? ' class="breakdown-row"' : ''
			html += `<tr${data}${breakdownRow}>`
			if (this.showAncestors) {
				let ancestors = _.get(this.options.response, `ancestors.${value}`, '')
				html += `<td${rowspanStr}>${_.escape(ancestors)}</td>`
			}

			// Provide unshortened tooltips for shortened values which are displayed in the cell
			var { shortened, unshortened } = shortenedAndUnshortened({value})
			if ((shortened != unshortened) && shortened === label) {
				html += `<td ${levelStr} ${rowspanStr} class="${indent} ${drilldownClass}">
					<span class="is-shortened"
						data-field="${this.firstFieldLabel()}"
						data-unshortened-value="${unshortened}">
						${escapePreserveLineBreaks(label)}
					</span>
				</td>`
			} else {
				label = Dataset.isBlank(value) ?
					`<span class="blank-value">${escapePreserveLineBreaks(label)}</span>` :
					escapePreserveLineBreaks(label)
				html += `<td ${levelStr} ${rowspanStr} class="${indent} ${drilldownClass}">${label}</td>`
			}

			if (this.showKeys) {
				var text = this.keyDisplay.keys(value)
				html += '<td' + rowspanStr + '>' + _.escape(text) + '</td>'
			}
			var dataId = data // Grab before data gets new value
			_.each(rowsForValue, function(row, index) {
				if (this.rowBreakdownField) {
					if (index > 0) {
						html += `<tr ${dataId}>`
					}
					const rowBreakdown = this.options.table.get(getRepeatByGroupingKey('row'))
					let summaryType = rowBreakdown && rowBreakdown.summaryType
					var label = this.fieldLabel(this.rowBreakdownField,
						summaryType === 'range', row, rowBreakdown)
					var indent = ''
					let data = ` data-row-index=${index}` // Required for excel export
					if (isGeographicOrRollup(this.rowBreakdownField.dataType)) {
						data = ' data-row="' + row + '"'
						if (this.rowIndents && row != this.rowFirstId &&
							// blanks go last and aren't indented
							!Dataset.isBlank(row)) {
							indent = ' class="indent"'
						}
					}
					html += '<td' + data + indent + '>' + _.escape(label) + '</td>'
					if (this.showKeys && isGeographicOrRollup(this.rowBreakdownField.dataType)) {
						var text = this.keyDisplay.keys(row)
						html += '<td>' + _.escape(text) + '</td>'
					}
				}
				_.each(this.columnArray, function(column) {
					// #15352 don't use BLANK for blank values.  Just use nil
					var key = cleanObject({ value, row, column })
					var datum = this.map.get(Immutable.fromJS(key))
					html += this.aggregationHtml(this.aggregations, datum, key)
				}.bind(this))
				if (this.rowBreakdownField && index > 0) {
					html += '</tr>'
				}
				// newRowNeeded = true
			}.bind(this))
			if (!this.rowBreakdownField) {
				html += '</tr>'
			}

			// if we aren't displaying breakdowns and have just rendered the
			// last row we're supposed to
			if (!this.hasBreakdown() && this.numDisplayed - 1 == valueIndex) {
				// stop rendering more rows
				return false
			}
		}.bind(this))
		return html
	},

	othersHtml: function() {
		let html = ''
		if (!this.hasBreakdown() && this.numDisplayed < this.valueArray.length) {
			let ancestorsCell = this.showAncestors ? '<td></td>' : ''
			var indent = this.valueIndents ? ' class="indent"' : ''
			html += `<tr data-id="${OTHER}" ${indent}>`
			var howManyMore = Math.min(RENDER_INCREMENT,
				this.valueArray.length - this.numDisplayed)
			var label = _.escape(i18n.get('common.other'))
			label += ' <span class="show-more">' +
				_.escape(i18n.get('datasets.showMore', howManyMore)) +
				'</span>'
			var keysCell = ''
			if (this.showKeys) {
				keysCell = '<td></td>'
			}

			html +=
				ancestorsCell +
				'<td class="drilldown">' + label + '</td>' +
				keysCell +
				this.aggregationHtml(this.aggregations, this.getOtherDatum(),
					OTHER_KEY, { other: true }) +
				'</tr>'
		}
		return html
	},

	firstFieldLabel: function() {
		return _.escape(this.model.getFieldLabelByIds(this.options.result))
	},

	/**
	 * Returns the appropriate aggregation type for the given aggregation
	 */
	getDataType: function(aggregation) {
		let dataType
		if (aggregation.dataSourceType === 'calculated') {
			dataType = aggregation.dataType
		} else {
			let field = this.model.combinedFieldsById[aggregation.fieldId]
			let underlyingField = this.model.getUnderlyingField(field)
			let fieldDataType = underlyingField?.dataType ?? NUMBER
			dataType = getAggregatedDataType(fieldDataType,
				aggregation.aggregationType)
		}
		return dataType
	},

	/**
	 * Returns the HTML for the aggregation columns
	 * @param {Array} aggregations the aggregation/column definitions
	 * @param {Array} values the values for the aggregations/columns
	 * @param {Object} key contains the row and breakdown information that
	 * identifies the cell the value will be displayed in
	 * @param {String|Number} [key.value] associates cell to row
	 * @param {String|Number} [key.row] associates cell to row breakdown (if set)
	 * @param {String|Number} [key.column] associates cell to column breakdown (if set)
	 * @param {Boolean} [options.other=false] indicates that the numbers being
	 * displayed are for the "Other" row
	 */
	aggregationHtml: function(aggregations, values, key, options) {
		var html = ''
		_.each(aggregations, (aggregation, index) => {
			let value = _.get(values, index)
			let field = this.model.combinedFieldsById[aggregation.fieldId]
			// the data type for the data displayed in the current column of the
			// dataset table
			var dataType = this.getDataType(aggregation)

			value = coerceNilAggregatedValue(value, aggregation, options)

			let valueOptions = {
				value,
				dataType,
				dataset: this.model,
				fieldId: field?.id,
				treeItemsById: this.options.treeItemsById,
				currencyCode: _.get(field, 'currencyCode'),
				precision: datasetValuePrecision({
					field,
					configuredPrecision: aggregation.precision
				})
			}

			// figure out whether we want to include a <span class="value">
			// wrapper around the value displayed.  We don't want to include it
			// for dates and we don't want to include it for calculated columns
			// because you can't create dataset metrics for those (#28132)
			let valueBegin, valueEnd
			let shortened = formatHtmlValue(valueOptions)
			let unshortened = formatHtmlValue(_.extend({ shorten: false }, valueOptions))
			let isCalculated = _.get(aggregation, 'dataSourceType') === 'calculated'
			const escapedAggLabel = _.escape(aggregationLabel(this.model, aggregation))
			let listUniqueValues = aggregation.aggregationType == LIST_UNIQUE_VALUES
			if (!isNumericDataType(dataType) || isCalculated || listUniqueValues) {
				valueBegin = valueEnd = ''

				if (isCalculated && shortened != unshortened) {
					valueBegin = `<span class="value is-shortened" ` +
						'data-unshortened-value="' + unshortened +
						'" data-field="' + escapedAggLabel + '">'
					valueEnd = '</span>'
				}
			} else {
				if (this.options.explore) {
					value = key == OTHER_KEY ? '' : 'value text-link-emphasized'
				} else {
					value = 'value'
				}

				if (shortened != unshortened) {
					valueBegin = `<span class="${value} is-shortened" ` +
						'data-unshortened-value="' + unshortened +
						'" data-field="' + escapedAggLabel + '">'
				} else {
					valueBegin = `<span class="${value}" ` +
						'data-field="' + escapedAggLabel + '">'
				}

				valueEnd = '</span>'
			}

			var formatted = formatHtmlValue(_.extend({ shorten: _.get(this.options.table.attributes, 'abbreviateNumbers', true) }, valueOptions))
			const dataAttributes = key || {}
			dataAttributes['field-id'] = aggregation.fieldId
			dataAttributes['visible-linked-field-id'] = aggregation.visibleLinkedFieldId
			dataAttributes['aggregation-type'] = aggregation.aggregationType
			dataAttributes['aggregation-index'] = index // excel export requires this
			const keyHtml = _.reduce(dataAttributes, function(html, value, name) {
				html += ' data-' + name + '="' + _.escape(value) + '"'
				return html
			}, '')
			var firstBreakdownColumn = this.hasColumnBreakdown() && index % aggregations.length == 0
			var breakdownClass = firstBreakdownColumn ? ' class="column-breakdown"' : ''
			// #19134 don't show numbers for other rows when displaying a list,
			// children or grandchildren
			if (key == OTHER_KEY &&
				(this.getSummaryType() == 'list' ||
				this.getSummaryType() == 'grandchildren' ||
				this.getSummaryType() == 'great-grandchildren')) {
				valueBegin = valueEnd = formatted = ''
			}
			html += `<td${keyHtml}${breakdownClass}>${valueBegin}${formatted}${valueEnd}</td>`
		})
		return html
	},

	/**
	 * Constructs a label for a field's value, e.g. converts a number breakdown
	 * range into a String like "13 to 25"
	 * @param {DatasetField} field the field
	 * @param {Boolean} range true if the value is a range ID from a range
	 * @param {Object} value the value to be formatted
	 * @param {DatasetTabularGrouping} [grouping] the grouping within the table
	 */
	fieldLabel: function(field, range, value, grouping) {
		field = new DatasetField(this.model.getUnderlyingField(field))

		let groupCalendarId = _.defaultTo(_.get(grouping, 'groupCalendarId'),
			_.get(this.groupCalendar, 'id'))
		let breakdownCalendarId = _.defaultTo(_.get(grouping, 'breakdownCalendarId'),
			_.get(this.breakdownCalendar, 'id'))
		let summaryType = grouping ? grouping.summaryType :
			this.getSummaryType()
		summaryType = summaryType ?? getChooseSummaryTypeDefault(
			this.options.field, this.filters, this.model)

		const attributes = _.extend({
			summaryType,
			timeDisplayType: field?.get?.('timeDisplayType'),
			groupCalendarId,
			breakdownCalendarId,
			abbreviateNumbers: _.get(this.options.table.attributes, 'abbreviateNumbers', true)
		}, unwrapModel(field))

		return formatSummaryValue(attributes, value, {
			datasetField: field,
			treeItemsById: this.options.treeItemsById,
			valueIsRangeId: range,
			dataset: this.model,
			grouping
		})
	},

	/**
	 * Returns a function that compares two values for a field for sorting
	 * purposes.  Uses the format expected by Array.sort so that 'blank' and
	 * 'not-in-any' can be handled robustly and not with magic constants like
	 * Number.MAX_VALUE.  Another benefit of doing it this way is the logic
	 * for BLANK and NOT_IN_ANY can be handled once rather than needing to be
	 * done over and over for each type of field
	 *
	 * @param {Boolean} range true if the values being sorted are range IDs
	 *
	 * @param {String} [summaryType=this.getSummaryType()] the summaryType for
	 * the field being sorted
	 *
	 * @returns {Function}
	 */
	getFieldComparator: function(field, range, summaryType) {
		let sortFirstTreeIdsByFieldId = _.get(this.options, 'result.sortFirstTreeIds')
		field = this.model.getUnderlyingField(field)
		summaryType = summaryType || this.getSummaryType()
		if (!field.attributes) {
			field = new DatasetField(field)
		}
		return (a = BLANK, b = BLANK, opts = {}) => {
			let val = (() => {
				if (a == BLANK) {
					return 1
				}
				if (a == NOT_IN_ANY) {
					if (b == BLANK) {
						return -1
					} else if (b == NOT_IN_ANY) {
						return 0
					} else {
						return 1
					}
				}
				if (b == BLANK) {
					return -1
				}
				// if we reach here, "a" isn't blank or not-in-any so "a" goes before it
				if (b == NOT_IN_ANY) {
					return -1
				}

				// if we have a tree item that should be sorted to the top (#11524)
				// #19235 do not do this if viewing rollup tree in "list" display
				if (isGeographicOrRollup(field.get('dataType')) && sortFirstTreeIdsByFieldId && this.getSummaryType() != 'list') {
					var sortFirstTreeId = sortFirstTreeIdsByFieldId[field.id]
					if (sortFirstTreeId == a) {
						return -1
					}
					if (sortFirstTreeId == b) {
						return 1
					}
				}

				var byFieldLabel =
					isGeographicOrRollup(field.get('dataType')) ||
					(field.get('dataType') === TEXT && range)

				if (byFieldLabel) {
					var labelA = this.fieldLabel(field, range, a)
					var labelB = this.fieldLabel(field, range, b)
					return this.collator.compare(labelA, labelB)
				}

				if (field.get('dataType') === TEXT) {
					return this.collator.compare(a || '', b || '')
				}

				if (isNumericDataType(field.get('dataType'))) {
					if (range) {
						function rangeVal(val) {
							// for numeric breakdown ranges, order numerically
							var range = field.ranges.get(val)
							if (_.isNil(range.get('low'))) {
								return range.get('high')
							}
							if (_.isNil(range.get('high'))) {
								return range.get('low')
							}
							return (range.get('high') + range.get('low')) / 2
						}
						return rangeVal(a) - rangeVal(b)
					} else {
						return Number(a) - Number(b)
					}
				}

				if (field.get('dataType') === YES_NO) {
					// both yes or both no is equal
					if (!!a == !!b) {
						return 0
					}
					// if a is yes, it goes first.  if it's not yes, then it's no
					// and goes second
					return a ? -1 : 1
				}

				if (summaryType === 'similar-time-ranges' &&
					!isDayOfTheWeek(this.options.table) &&
					!isMonthOfTheYear(this.options.table)) {
					return a - b
				}
				if (_.includes([DATE, DATE_TIME, CALENDAR_PERIOD], field.get('dataType'))) {
					return dateSortValue(a) - dateSortValue(b)
				}
				if (field.get('dataType') === TIME) {
					const toInt = time => parseInt(time.replace(':', ''))
					return toInt(a) - toInt(b)
				}
			})()
			return opts.reversed ? val * -1 : val
		}
	},

	/**
	 * Returns metadata used in rendering <td>s for aggregation columns
	 * has the side effect of updating the this.columnIndexToColumnValue object
	 * @param {Object[]} aggregations
	 * @returns {Array<{
	 *     text: string,
	 *     errorHtml: string,
	 *     columnBreakdown: boolean,
	 *     isSortable: boolean,
	 *     coordinates: {
	 *         x: number,
	 *         y: number
	 *     }
	 * }>}
	 */
	aggregationsMetadata: function(aggregations) {
		const columnBreakdownField = this.getBreakdownField('column')
		return _.flatMap(this.columnArray, (column, colIdx) => {
			if (!_.isNil(column)) {
				this.columnIndexToColumnValue[colIdx] = column
			}
			return _.map(aggregations, (aggregation, idx) => {
				let errorHtml = ''
				let aggregationError = _.get(this.options.result, `aggregationErrors.${idx}`)
				if (aggregationError) {
					errorHtml = '<div class="aggregation-error">' +
						icon('warn') + '<div>'
				}
				const firstBreakdownHeader = columnBreakdownField && idx % aggregations.length == 0
				return {
					text: aggregationLabel(this.model, aggregation),
					columnBreakdown: !!firstBreakdownHeader,
					isSortable: !this.hasRowBreakdown(),
					coordinates: {
						x: idx,
						y: colIdx
					},
					errorHtml
				}
			})
		})
	},

	/**
	 * Returns whether this results display has a breakdown included
	 */
	hasBreakdown: function() {
		var hasBreakdown = this.hasColumnBreakdown() || this.hasRowBreakdown()
		return !!hasBreakdown
	},

	hasRowBreakdown: function() {
		return !!(_.get(this.options.table.get(getRepeatByGroupingKey('row')), 'fieldId'))
	},

	hasColumnBreakdown: function() {
		return !!(_.get(this.options.table.get(getRepeatByGroupingKey('column')), 'fieldId'))
	},

	isHidingPanelContents: function() {
		// #26689 Inconsistent display when no results found
		let totalIs0 = this.options.response.total == 0 && (
			isTotal(this.options.aggregationFieldId) ||
			_.isNil(this.options.aggregationFieldId)
		)

		let emptyTable = this.$('tbody tr').length == 0
		if (emptyTable && (this.options.numResults == 0 || totalIs0)) {
			// if there are no results, there's nothing helpful to display
			this.$el.addClass('no-results')
			return true
		} else {
			this.$el.removeClass('no-results')
		}

		// if a filter is invalid, we can't display it
		const valid = this.options.table.get('valid')
		if (!_.isNil(valid) && !valid) {
			return true
		}

		// if there's a breakdown, don't hide the panel contents.  This must go
		// before any logic based on the field type!  If you have breakdowns
		// you really should be displaying panel content
		if (this.hasBreakdown()) {
			return false
		}

		// if the panel has columns with information that isn't obvious from the
		// total display at the top, we need to show the panel
		var i, aggregation
		var aggregationFieldId = this.options.aggregationFieldId || TOTAL
		var aggregations = this.getAggregations()
		for (i=0; i<_.size(aggregations); i++) {
			aggregation = aggregations[i]
			// if we're displaying a column for a totally different field,
			// definitely display the panel contents
			if (aggregation.fieldId != aggregationFieldId) {
				return false
			}
			// if we're looking at a specific field
			if (!isTotal(aggregationFieldId)) {
				// percentage columns will always be 100% if there's one row
				// so if those are around we can still hide the panel, but we
				// can't hide the panel if the total display is sum and there
				// is a column showing the average (or vice versa)
				if (aggregation.aggregationType != 'percentage' &&
					aggregation.aggregationType != this.options.aggregationType) {
					return false
				}
			}
		}

		if (_.size(this.filters) == 1) {
			let filter = this.filters[0]

			const dataType = this.underlyingField.dataType
			if (dataType === TEXT) {
				if (filter.operator === 'equals' ||
					filter.operator === 'not-in-any-range') {
					return true
				}
			}

			if (isGeographicOrRollup(dataType)) {
				if (filter.operator === 'not-blank') {
					// it would be confusing to display the tree items.  what would
					// be displayed for the counts?  would it include descendants
					// or not?
					return true
				}
			}
		}

		return false
	},

	isShowingRanges: function() {
		const table = this.options.table
		const summaryType = table && table.get('summarType')
		return summaryType == 'range' ||
			(_.isNil(summaryType) && !_.isEmpty(_.get(this.options, 'field.ranges')))
	},

	/**
	 * Returns whether all results should be displayed, instead of just the
	 * first few
	 */
	isShowingAll: function() {
		return this.isShowingRanges()
	},

	/**
	 * Retrieves the value used to sort results if there are ties (#15374).
	 * Unfortunately there's some nearly identical code in
	 * DatasetsQueryDao.getValueComparable
	 */
	getValueComparable: function(value) {
		// note: do not alter null values. The sorter automatically handles how
		// nulls should be treated. We don't sort based on nulls to ensure
		// em dashes (standins for rollups that are not available) are sorted
		// before nulls
		// #24651 handle undefined to be the same as null.
		if (_.isUndefined(value)) {
			return null
		}
		if (NOT_IN_ANY == value) {
			return Number.MAX_VALUE
		}
		const summaryType = this.options.table.get('summaryType')
		if (isDayOfTheWeek(this.options.table)) {
			switch (value) {
				case 'monday': return 1
				case 'tuesday': return 2
				case 'wednesday': return 3
				case 'thursday': return 4
				case 'friday': return 5
				case 'saturday': return 6
				case 'sunday': return 7
			}
		}
		if (isMonthOfTheYear(this.options.table)) {
			switch (value) {
				case 'january': return 1
				case 'february': return 2
				case 'march': return 3
				case 'april': return 4
				case 'may': return 5
				case 'june': return 6
				case 'july': return 7
				case 'august': return 8
				case 'september': return 9
				case 'october': return 10
				case 'november': return 11
				case 'december': return 12
			}
		}
		if (summaryType === 'similar-time-ranges') {
			return value
		}

		const dataType = this.underlyingField.dataType
		if (isGeographicOrRollup(dataType)) {
			return this.options.treeItemsById[value].label
		}
		if (dataType === CALENDAR_PERIOD) {
			return _.get(calendars.periodsById[value], 'label', '')
		}
		if (dataType === TEXT &&
			summaryType !== 'range') {
			return value
		}
		if (summaryType === 'value') {
			return value
		}
		if (dataType === DATE || dataType === DATE_TIME) {
			const calendar = calendars.periodsById[value]
			if (calendar) {
				return -1 * calendar.end.unix()
			}
		}
		// returning 0 means don't change the order
		return 0
	},

	getAggregationComparable: function(value, index) {
		if (_.isNil(value)) return value

		//note this foregoes lodash "get" method for performance reasons (#17269)
		const aggregations = this.options.table.get('aggregations')
		if (aggregations) {
			let aggregation = aggregations[index]
			if (!aggregation) return value

			let date = false
			if (aggregation.dataSourceType === 'calculated' &&
				aggregation.dataType === DATE) {
				date = true
			} else {
				let field = this.model.combinedFieldsById[aggregation.fieldId]
				if (field && field.dataType === DATE) {
					date = true
				}
			}
			if (date) {
				value = moment(value).unix()
			}
		}
		return value
	},

	getValueSorter: function() {
		return new Sorter({
			collator: this.collator,
			alphanumeric: this.isTableFieldAlphanumeric(),
			toValue: (datum) => { return this.getValueComparable(datum.value) }
		})
	},

	/**
	 * Sorts the values displayed to the user (called "Rows" in the UI).  If
	 * there are no breakdown, the values are sorted by the first column of
	 * numbers in the results, descending.  Otherwise the values are sorted alphabetically,
	 * with a few special rules (e.g. children/grandchildren are in tree order,
	 * and blank goes at the end).
	 */
	sortValuesByDefaultOrder: function(values) {
		// if showing children with breakdown or grandchildren or great-grandchildren, results are in tree order
		if (this.sortDefaultByRollupTree) {
			// Sort by leftbound, which is the order the elements are in the
			// tree.  Put blanks last
			return _.sortBy(values, treeId => _.isNil(treeId) ? Number.MAX_VALUE : this.treeInfoById[treeId].leftBound)
		}

		// if there's a row or column breakdown
		if (this.hasBreakdown() || this.isShowingRanges()) {
			return new Sorter({
				alphanumeric: this.isTableFieldAlphanumeric(),
				collator: this.collator,
				compare: this.getFieldComparator(this.underlyingField, this.showingRangesForValues)
			}).sort(values).results
		} else {
			let sortFirstTreeId = this.getValueSortFirstTreeId()
			let firstAggregationType = this.getAggregations()[0].aggregationType

			//the default sort is on the first aggregation in descending order in most cases except when
			//the first aggregation is a minimum/earliest aggregation type.  In that scenario the default
			//order is ascending since we're aggregating from smallest to largest
			let descending = firstAggregationType != 'minimum'

			let sorterOpts = {
				caseSensitive: false,
				accentSensitive: false,
				reversed: descending,
				collator: this.collator,
				alphanumeric: false,	//default sort is first aggregation which is always numerical
				toValue: datum => {
					if (sortFirstTreeId) {
						if (datum.value == sortFirstTreeId) {
							//#19856 for minimum aggregations we reverse the default order, so to keep the
							//tree parent on top we must give it the lowest number
							return firstAggregationType == 'minimum' ? -Number.MAX_VALUE : Number.MAX_VALUE
						}
						// blanks go last when in the tree view
						if (this.getSummaryType() === 'tree' && Dataset.isBlank(datum.value)) {
							return firstAggregationType == 'minimum' ? Number.MAX_VALUE : -Number.MAX_VALUE
						}
					}
					return this.getAggregationComparable(datum.aggregations[0], 0)
				},
				compound: this.getValueSorter()		//handle ties #15374
			}
			let unsortedData = _.get(this.options, 'result.data')
			let sortedData = new Sorter(sorterOpts).sort(unsortedData).results
			return _(sortedData).map('value').value()
		}
	},

	isTableFieldAlphanumeric: function() {
		let fieldDataType = this.underlyingField.dataType
		let table = unwrapModel(_.result(this.options, 'table'))
		let summaryType = _.get(table, 'summaryType')
		return isGeographicOrRollup(fieldDataType) || (fieldDataType === TEXT && summaryType !== 'range')
	},

	isBreakdownFieldAlphanumeric: function (key) {
		let sortFirstTreeIdsByFieldId = this.options.result.sortFirstTreeIds
		let field = this.getBreakdownField(key)
		if (!field.attributes) {
			field = new DatasetField(field)
		}
		let dataType = field.get('dataType')
		return dataType === TEXT || isGeographicOrRollup(dataType) && _.isNil(sortFirstTreeIdsByFieldId)
	},

	/**
	 * Sorts the row breakdown values
	 */
	sortRowsByDefaultOrder: function(values) {
		return this.sortBreakdown(values, 'row')
	},

	/**
	 * Sorts the column breakdown values
	 */
	sortColumnsByDefaultOrder: function(values) {
		return this.sortBreakdown(values, 'column')
	},

	sortBreakdown: function(values, key) {
		return new Sorter({
			alphanumeric: this.isBreakdownFieldAlphanumeric(key),
			collator: this.collator,
			compare: this.getBreakdownComparator(key)
		}).sort(values).results
	},

	getBreakdownComparator: function(key) {
		var field = this.getBreakdownField(key)
		let summaryType = _.get(this.options.table.get(getRepeatByGroupingKey(key)), 'summaryType')
		var range = summaryType === 'range'
		return this.getFieldComparator(field, range, summaryType)
	},

	hasItemOnlyFilter: function(treeNodeId, fieldId) {
		// get all rollupIsAny filters for the field
		// grouped by filter
		let rollupIsAnyFilterGroups = _(_.get(this.options, 'allFilters'))
			.filter(filter =>
				filter.fieldId == fieldId &&
				!_.isEmpty(filter.rollupIsAnyFilters))
			.map('rollupIsAnyFilters')
			.value()

		// check each filter's rollupIsAnyFilters for an item only or rollups only
		// filter applied to the node in question
		return _.some(rollupIsAnyFilterGroups, filterGroup => {
			let filterType = filterGroup[treeNodeId]
			return filterType === 'item-and-rollups' ||
				filterType === 'item-only' ||
				filterType === 'rollups-only'
		})
	},

	/**
	 * Returns the field for row or column breakdowns
	 * @param {String} key either 'row' or 'column'
	 */
	getBreakdownField: function(key) {
		const breakdown = this.options.table.get(getRepeatByGroupingKey(key))
		const fieldId = _.get(breakdown, 'fieldId')
		return this.model.combinedFieldsById[fieldId]
	},

	getBreakdownVisibleLinkedField: function(key) {
		const breakdown = this.options.table.get(getRepeatByGroupingKey(key))
		const visibleLinkedFieldId = _.get(breakdown, 'visibleLinkedFieldId')
		return this.model.visibleLinkedFieldsById[visibleLinkedFieldId]
	},

	clickRow: function(e) {
		var id = $(e.target).closest('[data-id]').data('id')
		// if the user clicks on an "Other" row
		if (id === OTHER && this.numDisplayed < this.valueArray.length) {
			// display RENDER_INCREMENT more results
			this.numDisplayed += RENDER_INCREMENT
			this.options.table.set('numResults', this.numDisplayed)
			this.renderRows()
			this.trigger('num-results', this.options.table, this.numDisplayed)
			// Something related to calling `renderRows` and redrawing the table forces the "other" link to zoom.
			// We don't want that to happen, so stop the event from being handled in canvas. See #24673
			e.stopPropagation()
		} else {
			this.trigger('drilldown', this.options.table, id)
		}
	},

	onClickResultError: function() {
		showPartialError(this.options.result.error)
	},

	onClickAggregationError: function(e) {
		let columnIndex = this.$(e.target).closest('th')
			.attr('data-column-index')
		showPartialError(_.get(this.options.result, `aggregationErrors.${columnIndex}`))
		// don't toggle the sort on the column
		e.stopPropagation()
	},

	back: function(e) {
		this.trigger('back', this.options.table, this.options.result)
	},

	getDatasetSeriesOptions: function(e) {
		const options = DatasetsResult.prototype.getDatasetSeriesOptions.apply(this, arguments)
		var target = e instanceof Element ? $(e) : $(e.target)
		var data = target.closest('td').data()
		let aggregation = this.getAggregations()[data.aggregationIndex]
		options.columnFieldId = data.fieldId
		options.columnVisibleLinkedFieldId = data.visibleLinkedFieldId
		options.columnAggregationType = data.aggregationType
		// copy over the settings from the "Base Percentages On" panel
		_.extend(options, _.pick(aggregation, 'percentageOf',
			'useColumnFilters', 'denominatorFilters'))
		// combine the table and column filters
		let filters = _.cloneDeep(options.filters) || []
		options.denominatorFilters = combineFilters(options.denominatorFilters, filters)
		if (aggregation.filters) {
			filters = combineFilters(filters, aggregation.filters)
		}
		options.filters = filters

		const table = this.options.table
		const rowBreakdown = table && table.get(getRepeatByGroupingKey('row'))
		let rowBreakdownFieldId = _.get(rowBreakdown, 'fieldId')
		const columnBreakdown = table && table.get(getRepeatByGroupingKey('column'))
		let columnBreakdownFieldId = _.get(columnBreakdown, 'fieldId')
		if (rowBreakdownFieldId) {
			options.row = {
				fieldId: rowBreakdownFieldId,
				visibleLinkedFieldId: _.get(rowBreakdown, 'visibleLinkedFieldId'),
				value: data.row,
				summaryType: rowBreakdown.summaryType
			}
		}
		if (columnBreakdownFieldId) {
			options.column = {
				fieldId: columnBreakdownFieldId,
				visibleLinkedFieldId: _.get(columnBreakdown, 'visibleLinkedFieldId'),
				value: data.column,
				summaryType: columnBreakdown.summaryType
			}
		}
		options.value = {
			fieldId: table && table.get('fieldId'),
			visibleLinkedFieldId: this.options.table.get('visibleLinkedFieldId'),
			value: data.value,
			summaryType: table && table.get('summaryType')
		}
		return options
	},

	setNumDisplayed: function(numDisplayed) {
		this.numDisplayed = numDisplayed
		this.renderRows()
	},

	_isSortFieldValid: function(sortField) {
		if (_.isNil(sortField)) return true		//default sort is always valid
		let missingBreakdownRowSort = sortField == BREAKDOWN_ROW && !this.hasRowBreakdown()
		let missingRollupFieldAncestorsSort = sortField == ROLLUP_FIELD_ANCESTORS && !this.options.table.get('showAncestors')
		let missingRollupFieldKeysSort = sortField == ROLLUP_FIELD_KEYS && !this.keyDisplay.isDisplayed()
		let missingBreakdownColumnSort = false
		let columnSort = parseColumnSortField(sortField)
		if (columnSort) {
			//verify the designated breakdown column is still there
			missingBreakdownColumnSort = columnSort.breakdownIndex >= this.columnArray.length
				|| columnSort.aggregationIndex >= this.getAggregations().length
		}
		return !missingBreakdownRowSort && !missingRollupFieldAncestorsSort &&
			!missingRollupFieldKeysSort && !missingBreakdownColumnSort
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.sortableTable, this.loadingDotsForLongSorts], 'remove')
	}

})

export default DatasetsTabularResult
export {
	BLANK,
	OTHER,
	NOT_IN_ANY,
	RENDER_INCREMENT,
	TABLE_FIELD,
	BREAKDOWN_ROW,
	ROLLUP_FIELD_ANCESTORS,
	ROLLUP_FIELD_KEYS,
	getAggregationSortField
}
DatasetsTabularResult.__filename__ = 'datasets/overview/datasets-tabular-result.js'
